import Prism from "prismjs";

// Need this to prevent Prism from running automatically: https://github.com/PrismJS/prism/pull/1087#issuecomment-274952728
// if (window.Prism) {
//   document.removeEventListener('DOMContentLoaded', Prism.highlightAll);
// } else {
//   window.Prism = { manual: true };
// }

export function codeHighlightHtmlString(htmlString) {
  var paramsToReplace = new Set(htmlString.match(/{{.*?}}/g));
  var escapeMap = {};
  var escapedHtmlString = htmlString;
  paramsToReplace.forEach((param) => {
    var paramId = makeId(24);
    escapedHtmlString = escapedHtmlString.replace(new RegExp(param, "g"), paramId);
    escapeMap[paramId] = param;
  });
  var parsedDocument = new DOMParser().parseFromString(escapedHtmlString, "text/html");
  var parsedTemplate = parsedDocument.body.firstChild;
  Prism.highlightAllUnder(parsedTemplate);
  var output = parsedTemplate.outerHTML;
  for (var paramId in escapeMap) {
    output = output.replace(new RegExp(paramId, "g"), escapeMap[paramId]);
  }

  return output;
}

function makeId(length) {
  var result = "";
  var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}
